// extracted by mini-css-extract-plugin
export default {"modalContainer":"tERIeGbpwWHP3HXm6KH1","title":"E8mLUugeny5ic3TgPhFC","subtitle":"Ee_He0GfgshNDKrVsUAk","buttonWrapper":"XLDG_Y5XUPggr3aSaMVA"};